export const GET_STEPS = "app/ONBOADING/GET_STEPS";
export const GET_STEPS_SUCCESS = "app/ONBOADING/GET_STEPS_SUCCESS";
export const GET_STEPS_FAILURE = "app/ONBOADING/GET_STEPS_FAILURE";

export const SET_CURRENT_STEP = "app/ONBOADING/SET_CURRENT_STEP";

export const SET_PASSWORD = "app/ONBOADING/SET_PASSWORD";
export const SET_PASSWORD_SUCCESS = "app/ONBOADING/SET_PASSWORD_SUCCESS";
export const SET_PASSWORD_FAILURE = "app/ONBOADING/SET_PASSWORD_FAILURE";

export const GET_PERSONAL_INFO = "app/ONBOADING/GET_PERSONAL_INFO";
export const GET_PERSONAL_INFO_SUCCESS =
  "app/ONBOADING/GET_PERSONAL_INFO_SUCCESS";
export const GET_PERSONAL_INFO_FAILURE =
  "app/ONBOADING/GET_PERSONAL_INFO_FAILURE";

export const SET_PERSONAL_INFO = "app/ONBOADING/SET_PERSONAL_INFO";
export const SET_PERSONAL_INFO_SUCCESS =
  "app/ONBOADING/SET_PERSONAL_INFO_SUCCESS";
export const SET_PERSONAL_INFO_FAILURE =
  "app/ONBOADING/SET_PERSONAL_INFO_FAILURE";

export const GET_PAYROLL_INFO = "app/ONBOADING/GET_PAYROLL_INFO";
export const GET_PAYROLL_INFO_SUCCESS =
  "app/ONBOADING/GET_PAYROLL_INFO_SUCCESS";
export const GET_PAYROLL_INFO_FAILURE =
  "app/ONBOADING/GET_PAYROLL_INFO_FAILURE";

export const SET_PAYROLL_INFO = "app/ONBOADING/SET_PAYROLL_INFO";
export const SET_PAYROLL_INFO_SUCCESS =
  "app/ONBOADING/SET_PAYROLL_INFO_SUCCESS";
export const SET_PAYROLL_INFO_FAILURE =
  "app/ONBOADING/SET_PAYROLL_INFO_FAILURE";

export const VALIDATE_EMPLOYEE = "app/ONBOADING/VALIDATE_EMPLOYEE";
export const VALIDATE_EMPLOYEE_SUCCESS =
  "app/ONBOADING/VALIDATE_EMPLOYEE_SUCCESS";
export const VALIDATE_EMPLOYEE_FAILURE =
  "app/ONBOADING/VALIDATE_EMPLOYEE_FAILURE";

export const GET_STEP_DATA = "app/ONBOADING/GET_STEP_DATA";
export const GET_STEP_DATA_SUCCESS = "app/ONBOADING/GET_STEP_DATA_SUCCESS";
export const GET_STEP_DATA_FAILURE = "app/ONBOADING/GET_STEP_DATA_FAILURE";

export const SET_FIELDS = "app/ONBOADING/SET_FIELDS";

export const SAVE_RESPONSE = "app/ONBOADING/SAVE_RESPONSE";
export const SAVE_RESPONSE_SUCCESS = "app/ONBOADING/SAVE_RESPONSE_SUCCESS";
export const SAVE_RESPONSE_FAILURE = "app/ONBOADING/SAVE_RESPONSE_FAILURE";

export const DELETE_ANSWER = "app/ONBOADING/DELETE_ANSWER";
export const DELETE_ANSWER_SUCCESS = "app/ONBOADING/DELETE_ANSWER_SUCCESS";
export const DELETE_ANSWER_FAILURE = "app/ONBOADING/DELETE_ANSWER_FAILURE";

export const UPDATE_STATUS = "app/ONBOADING/UPDATE_STATUS";
export const UPDATE_STATUS_SUCCESS = "app/ONBOADING/UPDATE_STATUS_SUCCESS";
export const UPDATE_STATUS_FAILURE = "app/ONBOADING/UPDATE_STATUS_FAILURE";

export const GET_REQUIRED_DOCS = "app/ONBOADING/GET_REQUIRED_DOCS";
export const GET_REQUIRED_DOCS_SUCCESS =
  "app/ONBOADING/GET_REQUIRED_DOCS_SUCCESS";
export const GET_REQUIRED_DOCS_FAILURE =
  "app/ONBOADING/GET_REQUIRED_DOCS_FAILURE";
